import styled from '@emotion/styled';

export const Scrollable = styled.div`
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
`;
